import API from '../api';

export default class AchievementService {
  constructor() {
    this.API = new API();
  }
  getStatistics = (body) => this.API.post('/payment/statistics', body);
}
